import { config } from "./config";

// Fundo (banco) que atende cada ops. O nome do banco é sempre `<fundo>_<stage>`,
// que é exatamente o que /availableFunds devolveria: aquele lambda lista o
// pg_database e monta `fundname = dbname.replace("_" + ENV, "")`. Derivar aqui
// evita uma request na rota crítica do render — enquanto ela estava em voo o
// dbName ficava vazio, a query da tela ficava `enabled: false` (e portanto
// `isLoading: false` no react-query v5) e a tela mostrava "não há nada" antes
// mesmo do skeleton aparecer.
const OPS_TO_FUND: Record<string, string> = {
  muve: "xama",
  entrego: "xama",
  indrive: "xama",
  agility: "xama",
  // romaneio_imile, romaneio_imile_financeiro e cadastro_franquia_imile vivem no
  // banco do fundo xama, junto das tabelas do entrego.
  imile: "xama",
};

// Ops fora do mapa usam um fundo homônimo (logus, rayo, bee), preservando o
// comportamento anterior de casar `fundname` com o nome da ops.
export function getFundDbName(ops: string): string {
  const key = ops.toLowerCase();
  return `${OPS_TO_FUND[key] ?? key}_${config.stage}`;
}
